import { useEffect, useState } from "react";
import styles from "../Ui.module.css";

export interface ToastMessage {
  /** Changes for each new message, so the same text shown twice still appears twice. */
  key: string;
  text: string;
}

/** A message that appears for a few seconds. Announced politely to screen readers. */
export function Toast({ message }: { message: ToastMessage | null }) {
  const [dismissed, setDismissed] = useState<string | null>(null);
  const key = message?.key;
  useEffect(() => {
    if (!key) return;
    const t = setTimeout(() => setDismissed(key), 4000);
    return () => clearTimeout(t);
  }, [key]);
  const visible = message !== null && dismissed !== message.key;
  return (
    <div
      className={`${styles.toast} ${visible ? styles.show : ""} no-print`}
      role="status"
      aria-live="polite"
    >
      {visible ? message.text : ""}
    </div>
  );
}
